import { gsap } from "gsap";
import history from "history/browser";
import queryString from 'query-string';

document.querySelectorAll('.js-article-filter-nav').forEach(nav => {

    const navItems = nav.querySelectorAll('.article-filter-nav__button');

    function selectButton(button) {
        if (!button.hasAttribute('aria-current')) {
            nav
                .querySelector('[aria-current="true"]')
                .removeAttribute('aria-current');
            button.setAttribute('aria-current', 'true');
        }
    }

    history.listen(({ action, location }) => {
        let selected = nav.querySelector('[data-filter="' + queryString.parse(location.search).category + '"]');
        if (selected) {
            selectButton(selected);
        }
    });

    if (navItems) {
        navItems.forEach(button => {
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                //isMouseOver = false;
                let search = { ...queryString.parse(history.location.search), ...{ 'category' : button.getAttribute('data-filter') }};
                history.push(history.location.pathname + '?' + queryString.stringify(search));
            });
        });
    }
});